import { forwardRef } from 'react';

import { Box, type BoxProps } from '@frontend/legacy-components';

interface AssistanceAvailableBackgroundProps extends BoxProps {
  boxSize?: number;
}
export const AssistanceAvailableBackground = forwardRef<
  HTMLDivElement,
  AssistanceAvailableBackgroundProps
>((props, ref) => {
  const boxSize: number = props.boxSize ?? 22;
  return (
    <Box
      ref={ref}
      display="inline-flex"
      boxSize={boxSize}
      alignItems="flex-start"
      position="absolute"
      top={`calc(50% - ${boxSize / 4}rem)`}
      right={`-${boxSize / 4}rem`}
      flexShrink={0}
      pointerEvents="none"
      background="radial-gradient(50% 50% at 50% 50%, rgba(151, 59, 246, .25) 31.9%, rgba(151, 59, 246, 0) 100%)"
      {...props}
    />
  );
});
AssistanceAvailableBackground.displayName = 'AssistanceAvailableBackground';
